import React from 'react';
import './Layout.css';
import icon from './images/login-logo.png';
import icon2 from './images/company-logo.png';
import icon3 from './images/breadcrumb.png';
import {
  Menu,
  MenuList,
  MenuButton,
  MenuItem,
  MenuItems,
  MenuPopover,
  MenuLink,
} from "@reach/menu-button";
import "@reach/menu-button/styles.css";

function Header() {
  return (
    <header className="head" >
      <h2 className="head-breadcrumb"> <img src={icon3}/></h2>
      <h2 className="head-logo"> <img src={icon2}/></h2>
      <Menu>
      <MenuButton className="head-button">Explore All Courses</MenuButton>
      <MenuList>
         <MenuItem>Popular Courses</MenuItem>
         <MenuItem>Business</MenuItem>
         <MenuItem>Computer Science</MenuItem>
         <MenuItem>Data Science</MenuItem>
         <MenuItem>Information Technology</MenuItem>
         <MenuItem>Art</MenuItem>
         <MenuItem>Business</MenuItem>
         <MenuItem>View All</MenuItem>

      </MenuList>
      </Menu>
      <input className="head-input"type="text" placeholder="What courses do you want to learn?">
      </input>
      <ul className="nav">
        <li >Courses</li>
        <li >Workshop</li>
        <li >Activities</li>
        <li> <img src={icon}/></li>
      </ul>
      
    </header>
  )
}


export default Header;